export const getNumberInitials = (input: string, number: number) => {
    const removeVietnameseTones = (str: string) => {
        return str
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .replace(/đ/g, 'd')
            .replace(/Đ/g, 'D');
    };

    const cleaned = removeVietnameseTones(input)
        .trim()
        .split(/\s+/)
        .map(word => word[0]);

    let name: string = '';

    if (number < cleaned.length) {
        name = cleaned.slice(0, number).join('');
    } else {
        name = cleaned.slice(0, 2).join('');
    }

    return name;
};
